import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

const ITEM_FAVORITING_AB_TEST_NAME = 'Favorites_DriveItemFavoritesAdoption_Nov2025';
const ITEM_FAVORITING_DESKTOP_AB_TEST_NAME = 'Favorites_DesktopFavoritesAdoption_Feb2026';

let hasTrackedDesktopAbTest = false;

const isItemFavoritingVariant = (): boolean =>
    getAbTestV2(ITEM_FAVORITING_AB_TEST_NAME)?.variant === 'variant';

const isItemFavoritingFeb2026Variant = (): boolean =>
    getAbTestV2(ITEM_FAVORITING_DESKTOP_AB_TEST_NAME)?.variant === 'variant';

const isItemFavoritingFeb2026Control = (): boolean =>
    getAbTestV2(ITEM_FAVORITING_DESKTOP_AB_TEST_NAME)?.variant === 'control';

const trackItemFavoritingFeb2026Test = (): void => {
    if (!hasTrackedDesktopAbTest) {
        trackAbTestV2Variant(ITEM_FAVORITING_DESKTOP_AB_TEST_NAME);
        hasTrackedDesktopAbTest = true;
    }
};

export {
    isItemFavoritingVariant,
    isItemFavoritingFeb2026Variant,
    isItemFavoritingFeb2026Control,
    trackItemFavoritingFeb2026Test,
    ITEM_FAVORITING_AB_TEST_NAME,
    ITEM_FAVORITING_DESKTOP_AB_TEST_NAME,
};
